export const INITIAL_COLLECTIONS: any[] = [
  {
    "id": "9ed067e056d34183b0fac2611943cfe6",
    "title": "동북아역사재단 기타 간행도서 PDF",
    "description": "동북아역사재단 기타 게시판(2372)과 동북아역사자료센터에서 확인한 공식 PDF 자료입니다.",
    "tags": [
      "기타",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 59,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 49,
    "available_count": 49,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 10,
    "cancelled_count": 0,
    "local_count": 59,
    "external_count": 0,
    "total_size": 4216622244
  },
  {
    "id": "1df6aef4ed0147daaaaf9ed8dbded710",
    "title": "동북아역사재단 번역·외국어 도서 PDF",
    "description": "동북아역사재단 번역·외국어 도서 게시판(2370)과 동북아역사자료센터에서 확인한 공식 PDF 자료입니다.",
    "tags": [
      "번역·외국어 도서",
      "번역",
      "외국어",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 51,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 48,
    "available_count": 48,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 3,
    "cancelled_count": 0,
    "local_count": 51,
    "external_count": 0,
    "total_size": 1375991433
  },
  {
    "id": "a58ef34d98904d7e91c94f71bb3792e6",
    "title": "동북아역사재단 국제관계사 간행도서 PDF",
    "description": "동북아역사재단 국제관계사 게시판(2459)과 동북아역사자료센터에서 확인한 공식 PDF 원문 자료입니다.",
    "tags": [
      "국제관계사",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 83,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 74,
    "available_count": 74,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 9,
    "cancelled_count": 0,
    "local_count": 83,
    "external_count": 0,
    "total_size": 2525089726
  },
  {
    "id": "d4f9217339ec46398ca6ba35dcd063aa",
    "title": "동북아역사재단 독도·동해 표기 간행도서 PDF",
    "description": "동북아역사재단 공식 홈페이지 자료 > 간행도서 > 독도·동해 표기 게시판에서 다운로드 가능한 PDF 원문을 수집한 자료군입니다. 출처: https://www.nahf.or.kr/web/portal/bbs/2454/list",
    "tags": [
      "독도·동해 표기",
      "독도",
      "동해",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 50,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 44,
    "available_count": 44,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 6,
    "cancelled_count": 0,
    "local_count": 50,
    "external_count": 0,
    "total_size": 3165314024
  },
  {
    "id": "8996b0530e264a718e07daacf2ed020a",
    "title": "동북아역사재단 한일관계사 간행도서 PDF",
    "description": "동북아역사재단 공식 홈페이지 자료 > 간행도서 > 한일관계사 게시판에서 다운로드 가능한 PDF 원문을 수집한 자료군입니다. 출처: https://www.nahf.or.kr/web/portal/bbs/2458/list",
    "tags": [
      "한일관계사",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 243,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 211,
    "available_count": 211,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 32,
    "cancelled_count": 0,
    "local_count": 243,
    "external_count": 0,
    "total_size": 13691011555
  },
  {
    "id": "33572e6d27da468194de563559bd0fd0",
    "title": "동북아역사재단 한중관계사 간행도서 PDF",
    "description": "동북아역사재단 공식 홈페이지 자료 > 간행도서 > 한중관계사 게시판에서 다운로드 가능한 PDF 원문을 수집한 자료군입니다. 출처: https://www.nahf.or.kr/web/portal/bbs/2457/list",
    "tags": [
      "한중관계사",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 251,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 221,
    "available_count": 221,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 30,
    "cancelled_count": 0,
    "local_count": 251,
    "external_count": 0,
    "total_size": 23888408928
  }
];

export const INITIAL_TAGS: any[] = [
  {
    "id": "eb97befd37bb41deb1a3e7f9c4a114fc",
    "name": "간행도서",
    "color": "#14b8a6",
    "created": "2026-06-26 09:41:36"
  },
  {
    "id": "66db51b395814196891ea12b1455d76f",
    "name": "공식 PDF",
    "color": "#ef4444",
    "created": "2026-06-26 09:41:36"
  },
  {
    "id": "b0f363798b674b7e8987bd9f40888d87",
    "name": "국제관계사",
    "color": "#8b5cf6",
    "created": "2026-06-26 15:51:24"
  },
  {
    "id": "47babfa21f08477e808cf3b6e7e31e2e",
    "name": "기타",
    "color": "#f97316",
    "created": "2026-06-26 16:09:54"
  },
  {
    "id": "hklvkirqgxxavvhyketxkjdgsuoprsrh",
    "name": "독도",
    "color": "#22c55e",
    "created": "2026-04-07 11:58:17"
  },
  {
    "id": "b02af7f0440c4412ac36bc342903dd2e",
    "name": "독도·동해 표기",
    "color": "#22c55e",
    "created": "2026-06-26 09:59:42"
  },
  {
    "id": "93d0e851845a4551a5a6c12bd4f48a3f",
    "name": "동북아역사재단",
    "color": "#78716c",
    "created": "2026-06-26 09:41:36"
  },
  {
    "id": "1c1e76fe86c34e7a850e958b7ec8246f",
    "name": "동해",
    "color": "#06b6d4",
    "created": "2026-06-26 09:59:42"
  },
  {
    "id": "d754dca6f0444a559785ee5bae36b7e9",
    "name": "번역",
    "color": "#0ea5e9",
    "created": "2026-06-26 16:09:47"
  },
  {
    "id": "7c0d3c2cea174498adfa956a87e9737b",
    "name": "번역·외국어 도서",
    "color": "#0ea5e9",
    "created": "2026-06-26 16:09:47"
  },
  {
    "id": "853120997d6b45f59dd5582af6e8e0e6",
    "name": "외국어",
    "color": "#6366f1",
    "created": "2026-06-26 16:09:47"
  },
  {
    "id": "96179298b88845428e414c5dc5dfb769",
    "name": "한일관계사",
    "color": "#ef4444",
    "created": "2026-06-26 09:54:33"
  },
  {
    "id": "5b5db42ae27d466e8a56ffcb618c2d96",
    "name": "한중관계사",
    "color": "#3b82f6",
    "created": "2026-06-26 09:41:36"
  }
];
